//Current Weather Types
export const GET_CURRENT_WEATHER_START = "GET_CURRENT_WEATHER_START";
export const GET_CURRENT_WEATHER_SUCC = "GET_CURRENT_WEATHER_SUCC";
export const GET_CURRENT_WEATHER_FAIL = "GET_CURRENT_WEATHER_FAIL";
